import type { ReactNode } from 'react';
import { Stack } from '@workramp/ui';
import { StyledInnerContainer } from './SettingsSidebarSubSection.styles';

interface SettingsSidebarSubSectionProps {
  children?: ReactNode;
}

export const SettingsSidebarSubSection = ({ children }: SettingsSidebarSubSectionProps) => (
  <StyledInnerContainer>
    <Stack size={4}>{children}</Stack>
  </StyledInnerContainer>
);
